// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCheese = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M15 8a2 2 0 11-4 0 2 2 0 014 0M8 18a2 2 0 100-4 2 2 0 000 4" />,
    <path
      fillRule="evenodd"
      d="M2 2h16.189l-.164 1.142a2.5 2.5 0 002.833 2.833L22 5.81v5.158l-.57.271a2.5 2.5 0 000 4.52l.57.271V22h-4.903l-.122-.858a2.5 2.5 0 00-4.95 0l-.122.858H2v-9.903l.858-.122a2.5 2.5 0 000-4.95L2 6.903zm2 2v1.256a4.501 4.501 0 010 8.488V20h6.256a4.501 4.501 0 018.488 0H20v-2.758a4.5 4.5 0 01-2-3.742c0-1.561.795-2.936 2-3.742V7.973A4.5 4.5 0 0116.028 4z"
    />
  );
export default SvgIconCheese;
